

import React, { memo } from 'react';
import cx from 'classnames';
import onEnterPressed from '@shootsta/on-enter-pressed';
import Text from '../../Text';
import '../styles/_stage.scss';
import ContentLoader from '../../ContentLoader';

import startCase from 'lodash.startcase';









function getPrimaryClass({ selected, disabled }) {
  if (disabled) {
    return 'stage--disabled';
  }

  return selected ? 'stage--selected' : 'stage--future';
}

function Stage({
  text,
  selected,
  onClick,
  disabled,
  showLoader = false,
  statusDot
}) {
  const className = getPrimaryClass({ selected, disabled });

  return (
    <>
      {showLoader ?
      <div className="stage__arrow">
          <div className="stage__arrow__left" />
          <div className="stage__arrow__ctr">
            <Text body className="stage__arrow__loader">
              <ContentLoader
              width={116}
              height={40}
              preserveAspectRatio="xMinYMid meet"
              speed={0}>

                <rect
                x="2%"
                y="20%"
                width="100%"
                height="64%"
                rx="10"
                ry="10" />

              </ContentLoader>
            </Text>
          </div>
          <div className="stage__arrow__right" />
        </div> :

      <div
        role="button"
        tabIndex={0}
        className={cx('stage', className, { 'stage--clickable': onClick })}
        onClick={!disabled && onClick}
        onKeyDown={!disabled && onEnterPressed({ onClick })}>

          <div className="stage__arrow">
            <div className="stage__arrow__left" />
            <div className="stage__arrow__ctr">
              <Text body className="stage__arrow__ctr__text">
                {startCase(text)}
              </Text>
              {statusDot ?
            <span
              className={cx('stage__status-dot', `stage__status-dot--${statusDot}`)}
              data-testid="stage-status-dot" /> :
            null}
            </div>
            <div className="stage__arrow__right" />
          </div>
        </div>}

    </>);

}

export default memo(Stage);